import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`socketio`}</h1>
    <h2>{`Running multiple nodes with socket.io`}</h2>
    <p><a parentName="p" {...{
        "href": "https://socket.io/docs/v4/using-multiple-nodes/"
      }}>{`https://socket.io/docs/v4/using-multiple-nodes/`}</a>{`
`}<a parentName="p" {...{
        "href": "https://socket.io/docs/v4/using-multiple-nodes/#why-is-sticky-session-required"
      }}>{`https://socket.io/docs/v4/using-multiple-nodes/#why-is-sticky-session-required`}</a></p>
    <h3>{`Sticky Headers`}</h3>
    <p>{`you can add a cookie to incoming request
here's how you do that for aws loadbalancer`}</p>
    <h3>{`Redis adapter`}</h3>
    <p><a parentName="p" {...{
        "href": "https://socket.io/docs/v4/redis-adapter/"
      }}>{`https://socket.io/docs/v4/redis-adapter/`}</a>{`
check out the architecture diagram on the page to get a better sense of how clustering could work with socketio.`}</p>
    <p>{`nodejs has some support for clustering?
`}<a parentName="p" {...{
        "href": "https://socket.io/docs/v4/using-multiple-nodes/#using-nodejs-cluster"
      }}>{`https://socket.io/docs/v4/using-multiple-nodes/#using-nodejs-cluster`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      